import type * as Leaflet from 'leaflet';

export async function loadLeaflet(): Promise<typeof Leaflet> {
  const module = await import('leaflet');
  return ('default' in module ? module.default : module) as typeof Leaflet;
}
